import { render, staticRenderFns } from "./big-quote.vue?vue&type=template&id=37192b4e"
import script from "./big-quote.vue?vue&type=script&lang=js"
export * from "./big-quote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports